// extracted by mini-css-extract-plugin
export default {"devider":"Devider_devider__X90jl"};